export default __webpack_public_path__ + "static/media/SK.ff88029e.ico";